import { Head, usePage } from "@inertiajs/react"
import { AccountHero, EmptyState, OrderRow } from "@/components/account/AccountParts"
import { PublicShell } from "@/components/PublicShell"
import type { AccountOrdersProps, PageProps } from "@/types/inertia"
import "@/styles/public-account.css"

const TITLE = "My orders"
const DESCRIPTION =
  "Every order and enquiry you have sent SOH GD Wines, newest first, and where each one is now: received, in design, approved, in production or delivered."

// My orders (/account/orders, M6 decision 13): every enquiry on the account,
// newest first; each row opens that enquiry's timeline.
export default function AccountOrders() {
  const { props } = usePage<PageProps<AccountOrdersProps>>()
  const { orders } = props

  return (
    <PublicShell>
      <Head title={TITLE}>
        <meta name="description" content={DESCRIPTION} />
        <meta property="og:title" content={TITLE} />
        <meta property="og:description" content={DESCRIPTION} />
      </Head>

      <AccountHero
        titleId="orders-title"
        back={{ href: "/account", label: "My account" }}
        eyebrow="Orders and enquiries"
        title="My orders"
        lede="Every order and enquiry you have sent us, newest first. Open one to see where it is now."
      />

      <section className="band band-charcoal acct-band" aria-labelledby="orders-title">
        <div className="shell">
          {orders.length > 0 ? (
            <ul className="acct-orders">
              {orders.map((order) => (
                <OrderRow key={order.id} order={order} />
              ))}
            </ul>
          ) : (
            <EmptyState
              level={2}
              eyebrow="Nothing sent yet"
              title="No orders yet"
              action={{ href: "/wines", label: "Browse our wines" }}
            >
              Choose your wines, mixed as you like from 100 bottles, and send us an order enquiry. You can
              follow every step from here.
            </EmptyState>
          )}
        </div>
      </section>
    </PublicShell>
  )
}
